import { actions }  from "../../actions/common/pagination";

export default function profile ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case actions.SET_PREVIOUS_PAGE: return setPreviousPage( newState, action.page );
        case actions.SET_NEXT_PAGE: return setPreviousPage( newState, action.page );
        case actions.SET_GO_TO_PAGE: return setPreviousPage( newState, action.page );
        default: return newState;
    }
}

function setPreviousPage( newState, page ) {
    newState.current_page = page;

    return newState;
}

function setNextPage( newState, page ) {
    newState.current_page = page;

    return newState;
}

function setGoToPage( newState, page ) {
    newState.current_page = page;

    return newState;
}



// WEBPACK FOOTER //
// src/client/reducers/common/pagination.js